import {useTranslation} from "react-i18next";
import {addToFavorite, removeFromFavorite} from "../../api/eventApi";

export default function FavoriteButton({id, isInFavorite, eventDataUpdate}) {
    const { t } = useTranslation();
    const onClickHandler = () => {
        if (!isInFavorite) {
            addToFavorite(id, () => eventDataUpdate({type: 'addToFavorite', id: id}))
        } else {
            removeFromFavorite(id, () => eventDataUpdate({type: 'removeFromFavorite', id: id}))
        }
    }

    return (
        <div onClick={onClickHandler} className="add-to-selected js-add-to-favorite">
            { isInFavorite ? t('conferences.inFavorite') : t('conferences.toFavorite') }
        </div>
    )
}
